<template>
  <v-container fluid class="kereses hirlista-oldal">
    <div class="page-content">
      <k-resize-observer @on-resize-rect="OnResizeHeader">
        <div class="flex-center-between">
          <v-btn
            icon
            large
            color="primary"
            class="back-btn"
            @click="$goBackTo({ name: 'Fooldal' })"
          >
            <i class="fas fa-chevron-left"></i>
          </v-btn>
          <div class="flex-fill ml-1">
            {{ osszesen }} találat erre a kifejezésre:
            <strong>{{ keresoSzoveg }}</strong>
          </div>
          <k-hamburger-icon v-if="isMobile"></k-hamburger-icon>
        </div>
        <div class="px-3 my-2">
          <v-text-field
            v-model="searchText"
            append-icon="fa-search"
            outlined
            dense
            hide-details
            :placeholder="nyelvesites['kereses_placeholder_text']"
            @click:append="Kereses"
            @keyup.enter="Kereses"
          ></v-text-field>
        </div>
      </k-resize-observer>
      <k-hir-kereses-lista
        :key="keresoSzoveg"
        :getHirek="GetHirek()"
        :osszesen.sync="osszesen"
        :headerHeight="headerHeight"
      ></k-hir-kereses-lista>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { hirService } from '../services/HirService';
import { AppStoreTypes } from '../store/modules/app';

export default {
  name: 'Kereses',
  data() {
    return {
      osszesen: 0,
      headerHeight: 70,
      searchText: '',
    };
  },
  async mounted() {},
  created() {},
  methods: {
    GetHirek() {
      return utolsoHir => {
        return hirService.GetHirekByKeresoszoveg({
          keresoszoveg: this.keresoSzoveg,
          utolsoHir: utolsoHir?.Id,
        });
      };
    },
    OnResizeHeader(e) {
      this.headerHeight = e.height + 24;
    },
    Kereses() {
      this.$router.push({ name: 'Kereses', query: { text: this.searchText } });
    },
  },
  computed: {
    ...mapGetters({ user: AppStoreTypes.user.get }),
    keresoSzoveg() {
      return this.$route.query.text;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {
    keresoSzoveg: {
      handler(v) {
        this.searchText = v;
      },
      immediate: true,
    },
  },
  components: {},
};
</script>
